export function CoffeeIllustration({ className }: { className?: string }) {
    return (
        <svg
            viewBox="0 0 64.1576 66.2344"
            fill="none"
            aria-hidden="true"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Group">
                <g id="Group_2">
                    <path
                        id="Vector"
                        d="M14.1798 53.5767C24.6598 61.0147 36.6899 60.5517 46.5399 52.8027C56.3799 45.0527 53.4498 21.4807 53.4498 21.4807C53.4498 21.4807 50.7198 26.8777 29.7298 26.9677C6.38982 27.0687 4.78988 22.5067 4.78988 23.1337C4.81988 33.4977 3.69977 46.1397 14.1798 53.5767Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_2"
                        d="M53.42 21.0462C53.15 23.8282 41.9199 26.9072 29.6899 27.1272C17.4499 27.3472 4.58002 24.4862 4.77002 23.0452C5.25002 19.5562 16.67 16.8982 28.91 16.6782C41.15 16.4572 53.75 17.5412 53.42 21.0462Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_3"
                        d="M47.3099 52.2774C51.6299 53.0054 57.08 55.3804 57.08 57.8344C57.08 61.9214 44.53 65.2344 29.04 65.2344C13.56 65.2344 1 61.9214 1 57.8344C1 55.6414 6.19994 53.1785 11.9399 51.8235"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_4"
                        d="M20.16 57.0455C20.16 57.0455 4.19005 59.1595 24.0401 60.8655C43.8801 62.5725 50.47 57.5365 45.7 57.0365C39.47 56.3835 40.37 56.7315 40.37 56.7315C40.37 56.7315 35.3301 58.9395 29.8001 59.0345C24.2101 59.1305 20.16 57.0455 20.16 57.0455Z"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_5"
                        d="M53.9399 27.1092C53.9399 27.1092 64.32 24.8012 63.05 35.2532C62.24 41.9012 53.63 41.2642 53.63 41.2642"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_6"
                        d="M54.03 31.0492C54.03 31.0492 59.01 30.2972 59.11 33.4022C59.29 39.2362 53.88 37.5532 53.88 37.5532"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_7"
                        d="M18.9 13.7862C18.58 13.1562 18.11 12.7382 18.24 11.9832C18.69 9.30119 23.36 7.84421 20.29 4.77021C20.03 4.51221 18.91 3.5412 18.73 3.5412"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_8"
                        d="M26.1899 11.4912C32.0199 8.57822 22.3899 3.96622 28.3199 1.00022"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_9"
                        d="M37.01 12.8842C29.48 10.3752 41.9 6.80621 35.86 3.78721"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_10"
                        d="M48.5302 23.9599C48.5302 23.9599 37.5201 21.4839 28.2501 21.7259C18.9801 21.9669 9.89014 25.0209 9.89014 25.0209C9.89014 25.0209 20.7101 27.1388 29.9801 26.8968C39.2501 26.6548 48.5302 23.9599 48.5302 23.9599Z"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
                <path
                    id="Vector_11"
                    d="M24.21 38.2412C25.56 36.1222 28.88 35.4322 32.75 37.9022C36.63 40.3722 37.4099 43.2152 36.0599 45.3342C34.7099 47.4532 31.74 48.0462 27.86 45.5762C23.99 43.1062 22.86 40.3612 24.21 38.2412Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector_12"
                    d="M25.7002 37.7815C25.9102 44.7095 33.6703 38.7255 34.2603 46.0625"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}
